import { queryOptions, useQuery } from '@tanstack/react-query';

import { mediaApi } from '../api/media-api';

import { mediaKeys } from './media-keys';

export function mediaQueryOptions(id: string) {
  return queryOptions({
    queryKey: mediaKeys.detail(id),
    queryFn: () => mediaApi.get(id),
  });
}

export function useMedia(id: string | null) {
  return useQuery({ ...mediaQueryOptions(id ?? ''), enabled: id !== null });
}
